var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useCreditPaymentContext } from "./CreditPaymentContext";
import { PaymentForm } from "../paymentForm";
import client from "../../http/client";
import { PaymentErrorNotice } from "./PaymentErrorNotice";
import { RadixLoading } from "../primitives/RadixLoading";
import { AVSCollectionDetails } from "../avsCollection";
import { useOrderIntent } from "../../providers";
import { createPaymentAttemptId } from "./paymentAttemptId";
import { createArrowpaySubmissionLock } from "./ArrowpaySubmissionLock";
import { getRecaptchaCardLastFour, getRecaptchaToken } from "./recaptcha";
var errorMessageMap = {
    "The Account field is not a valid credit card number.": "Please check the card number and try again.",
    "Invalid Expiration Month": "Please enter a valid expiration month (MM).",
    "Invalid Expiration Year": "Please enter a valid expiration year.",
    "Invalid CVV": "Please check the security code (CVV) and try again.",
    "Token Privileges Suspended": "Too many failed attempts. Please wait 20 minutes before trying again.",
};
export var ArrowpayPaymentForm = function () {
    var _a = useCreditPaymentContext(), handleCreditOrderComplete = _a.handleCreditOrderComplete, processorInfo = _a.processorInfo, paymentError = _a.paymentError, reportProcessorError = _a.reportProcessorError, billingInfo = _a.billingInfo, clearPaymentError = _a.clearPaymentError, setStage = _a.setStage, isGuestUser = _a.isGuestUser, hasAvsConfigs = _a.hasAvsConfigs, isAvsValid = _a.isAvsValid, markPaymentSubmitting = _a.markPaymentSubmitting, checkoutAddressId = _a.checkoutAddressId, checkoutUserId = _a.checkoutUserId, checkoutComment = _a.checkoutComment, isCurbsideOrder = _a.isCurbsideOrder, shouldSendSmsAlerts = _a.shouldSendSmsAlerts, hasMarketingOptIn = _a.hasMarketingOptIn, smsNumber = _a.smsNumber, signUpRewards = _a.signUpRewards;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(false), shouldSaveCard = _c[0], setShouldSaveCard = _c[1];
    var _d = useState(false), avsRequiredMessageVisible = _d[0], setAvsRequiredMessageVisible = _d[1];
    var submissionLockRef = useRef(createArrowpaySubmissionLock());
    var showSavePaymentOption = !isGuestUser;
    var avsIncomplete = hasAvsConfigs && !isAvsValid;
    var paymentFormDisabled = loading || avsIncomplete;
    var currentAddress = useOrderIntent().currentAddress;
    var rewardsSignupPayload = signUpRewards ? { sign_up_rewards: true } : {};
    useEffect(function () {
        if (!avsIncomplete) {
            setAvsRequiredMessageVisible(false);
        }
    }, [avsIncomplete]);
    var handlePaymentFieldBlockedAttempt = useCallback(function (event) {
        if (!avsIncomplete) {
            return;
        }
        var target = event.target;
        if (target instanceof HTMLElement && target.closest(".radix-avs-collection-form")) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        setAvsRequiredMessageVisible(true);
        var addressField = document.getElementById("avsAddress");
        if (addressField) {
            addressField.focus();
        }
    }, [avsIncomplete]);
    var releaseSubmission = useCallback(function () {
        submissionLockRef.current.release();
        setLoading(false);
        markPaymentSubmitting(false);
    }, [markPaymentSubmitting]);
    function processTokenResponse(res) {
        return __awaiter(this, void 0, void 0, function () {
            var rawMessage, mappedMessage, recaptchaToken, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!submissionLockRef.current.tryHandleTokenCallback()) {
                            return [2 /*return*/];
                        }
                        if ((res === null || res === void 0 ? void 0 : res.Errors) && Array.isArray(res.Errors) && res.Errors.length > 0) {
                            rawMessage = res.Errors[0];
                            mappedMessage = (_a = errorMessageMap[rawMessage]) !== null && _a !== void 0 ? _a : rawMessage;
                            reportProcessorError("arrowpay", { Message: mappedMessage });
                            releaseSubmission();
                            return [2 /*return*/];
                        }
                        if (!res || !Object.prototype.hasOwnProperty.call(res, "Token")) {
                            reportProcessorError("arrowpay", { Message: "We could not process your payment. Please try again or use a different payment method" });
                            releaseSubmission();
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getRecaptchaToken(processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.recaptcha)];
                    case 2:
                        recaptchaToken = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        reportProcessorError("arrowpay", error_1);
                        releaseSubmission();
                        return [2 /*return*/];
                    case 4:
                        client.post("/order/arrowpay", __assign({ payment_attempt_id: submissionLockRef.current.getPaymentAttemptId(), recaptcha_token: recaptchaToken, card_last_four: getRecaptchaCardLastFour(res.Last4), token: res.Token, cvv: res.CVV, address: billingInfo.billingAddress, zip: billingInfo.billingZipcode, comment: checkoutComment, should_save_card: shouldSaveCard, using_on_file: false, address_id: currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.id, user_id: checkoutUserId, is_curbside_order: isCurbsideOrder, should_send_sms_alerts: shouldSendSmsAlerts, sms_number: smsNumber, has_marketing_opt_in: hasMarketingOptIn }, rewardsSignupPayload)).then(function (jres) {
                            if (jres.status === 200) {
                                try {
                                    var orderJ = JSON.parse(jres.data.order_data);
                                    handleCreditOrderComplete(orderJ);
                                }
                                catch (error) {
                                    reportProcessorError("arrowpay", error);
                                }
                                return;
                            }
                            releaseSubmission();
                        }, function (err) {
                            reportProcessorError("arrowpay", err);
                            releaseSubmission();
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function handleSubmit() {
        if (!submissionLockRef.current.tryAcquire(createPaymentAttemptId())) {
            return;
        }
        setLoading(true);
        markPaymentSubmitting(true);
        clearPaymentError();
        try {
            DatacapWebToken.requestToken(processorInfo.token_key, "payment_form", processTokenResponse);
        }
        catch (error) {
            reportProcessorError("arrowpay", error);
            releaseSubmission();
        }
    }
    var avsErrorMessage = "Your billing address or zip code was incorrect.";
    var handlePaymentErrorAcknowledged = useCallback(function () {
        setStage("avs");
    }, [setStage]);
    return (React.createElement("div", { className: "radix-credit-payment-form radix-credit-payment-form--arrowpay", role: "region", "aria-label": "Card payment details" },
        React.createElement(PaymentErrorNotice, { error: paymentError, onAcknowledge: (paymentError === null || paymentError === void 0 ? void 0 : paymentError.defaultMessage) === avsErrorMessage
                ? handlePaymentErrorAcknowledged
                : undefined }),
        loading ? React.createElement(RadixLoading, { label: "Processing payment" }) : null,
        React.createElement("div", { style: { display: loading ? "none" : "block" } },
            avsRequiredMessageVisible ? (React.createElement("p", { className: "radix-error-message", role: "alert" }, "Billing details are required before entering payment information.")) : null,
            React.createElement("div", { onMouseDownCapture: handlePaymentFieldBlockedAttempt, onTouchStartCapture: handlePaymentFieldBlockedAttempt, onPointerDownCapture: handlePaymentFieldBlockedAttempt },
                React.createElement(PaymentForm, { id: "payment_form", disabled: paymentFormDisabled, fieldAttributes: {
                        cardNumber: { placeholder: 'Card number', "data-token": "card_number" },
                        expirationMonth: { placeholder: '(MM)', "data-token": "exp_month" },
                        expirationYear: { placeholder: '(YYYY)', "data-token": "exp_year" },
                        securityCode: { placeholder: 'Security code', "data-token": "cvv" }
                    }, savePaymentOption: showSavePaymentOption ? {
                        checked: shouldSaveCard,
                        onCheckedChange: setShouldSaveCard,
                        label: "Save this Payment Method",
                        disabled: loading,
                    } : undefined, onSubmit: handleSubmit },
                    React.createElement(AVSCollectionDetails, { onSubmit: function () { } }))))));
};
